module.exports = "<div id=\"hoverRes\">\n  <app-playhead></app-playhead>\n  <div id=\"yAsis\">\n  \t<span (click)=\"clickName($event)\" [ngClass]=\"{'selected': timelinesYaxis == 'name'}\">Name</span>/\n  \t<span (click)=\"clickLanguage($event)\" [ngClass]=\"{'selected': timelinesYaxis == 'language'}\">Language</span>\n  </div>\n <!--  <div id=\"name\"></div> -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/d3graph/d3graph.component.html
// module id = ../../../../../src/app/d3graph/d3graph.component.html
// module chunks = main